export enum UserPaymentStatus {
  new = 'NEW',
  firstPaymentPending = 'FIRST_PAYMENT_PENDING',
  paying = 'PAYING',
  renewalRequired = 'RENEWAL_REQUIRED',
}
